const InternalTransfer = {
    bulkInternalTransfer: () => "store/internal-movement/bulk",
    storeList:()=>'store/internal-movement/stores',
    barcodeSearch:()=>'store/internal-movement/inventory',
}

export default InternalTransfer